import React, { useEffect, useState } from "react";
import ProjectManagement from "../ProjectManagementList";
import formValidation from "utils/validations";
import { showFormErrors } from "utils/CommonFunctions";
import { checkErrors } from "utils/TableFunctions";
import { useDispatch } from "react-redux";
import {
  CreateProjectAction,
  GetProjectDetailsActon,
  UpdateProjectAction,
} from "store/actions/ProjectActions";
import { useNavigate, useParams } from "react-router-dom";
import { showToastAction } from "store/slices/commonSlice";
import { type } from "@testing-library/user-event/dist/type";

const ProjectContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  const [loading, setLoading] = useState(false);
  const [draftLoading, setDraftLoading] = useState(false);
  const [data, setData] = useState({
    releaseType: "label",
    projectName: "",
    projectType: "SINGLE",
    hasLicenseAgreement: false,
    licenseAgreementDocument: "",
    wroteTopline: true,
    writers: [],
    hasSideArtist: true,
    hasProducer: true,
    hasDifferentProducerForMixing: true,
    artworkCreated: true,
    musicVideoCreated: true,
    usedSample: true,
    sampleAgreementDocument: "",
  });
  const [isProjectCreated, setIsProjectCreated] = useState(false);
  const [writers, setWriters] = useState([
    { name: "" },
    { name: "" },
    { name: "" },
  ]);

  useEffect(() => {
    if (params?.id) {
      dispatch(
        GetProjectDetailsActon(params?.id, dispatch, (res) => {
          setData(res);
          setWriters(res?.writers);
        })
      );
    }
  }, [params?.id]);

  const addWriter = () => {
    const values = [...writers];
    values.push({ name: "" });
    setWriters(values);
  };

  const handleChange = ({ name, value }) => {
   
    const formErrors = formValidation(name, value, data);
    const newData = { ...data, [name]: value, formErrors };

    // Clear writers if `wroteTopline` is set to false
    if (name === "wroteTopline" && value === false) {
      setWriters([{ name: "" }]); // Reset to default
    }
  
    setData(newData);
  };

  const onSubmit = () => {
    // Only validate writers if `wroteTopline` is true
    let allWriters = { values: [], hasErrors: false };
    
    if (data.wroteTopline === true) {
      allWriters = checkErrors(writers, setWriters, ["name"], [], 1);
      
      if (allWriters?.values?.length === 0) {
        dispatch(
          showToastAction({
            type: "error",
            detail: "At least 1 writer is required.",
          })
        );
        addWriter();
        return; // Stop submission if validation fails
      }
    }
  
    // Proceed if form is valid and (writers are valid OR `wroteTopline` is false)
    if (showFormErrors(data, setData) && (!allWriters?.hasErrors || data.wroteTopline === false)) {
      if (params?.id) {
        const payload = {
          ...data,
          projectStatus:
            data?.projectStatus == "DRAFT"
              ? "IN_PROGRESS"
              : data?.projectStatus,
        };
        dispatch(
          UpdateProjectAction(
            params?.id,
            payload,
            allWriters?.values,
            setLoading,
            dispatch,
            navigate
          )
        );
      } else {
        dispatch(
          CreateProjectAction(
            data,
            allWriters?.values,
            setLoading,
            dispatch,
            navigate
          )
        );
      }
    }
  };
  
  const onSaveDraft = () => {
    // Only validate writers if `wroteTopline` is true
    let allWriters = { values: [], hasErrors: false };
    
    if (data.wroteTopline === true) {
      allWriters = checkErrors(writers, setWriters, ["name"], ["name"]);
    }
  
    if (showFormErrors(data, setData, ["projectName"], ["projectType"]) && 
        (!allWriters?.hasErrors || data.wroteTopline === false)) {
      const payload = {
        ...data,
        projectStatus: "DRAFT",
      };
      if (params?.id) {
        dispatch(
          UpdateProjectAction(
            params?.id,
            payload,
            allWriters?.values,
            setDraftLoading,
            dispatch,
            navigate
          )
        );
      } else {
        dispatch(
          CreateProjectAction(
            payload,
            allWriters?.values,
            setDraftLoading,
            dispatch,
            navigate
          )
        );
      }
    }
  };

  return {
    data,
    handleChange,
    writers,
    setWriters,
    addWriter,
    onSubmit,
    loading,
    onSaveDraft,
    draftLoading,
  };
};

export default ProjectContainer;
